
<div v-if="pro" class="full-logo">
  <img :src="ProLogo" v-show="!white" class="light-only" />
  <img :src="ProLogoWhite" :class="{ 'dark-only': !white }" />
</div>

<div v-else class="full-logo">
  <img :src="Logo" v-show="!white" class="light-only" />
  <img :src="LogoWhite" :class="{ 'dark-only': !white }" />
</div>
